export default __webpack_public_path__ + "static/media/tomcat.be17018d.svg";